(function () {
	'use strict';
	// if client.js return data from installed AV
	var $ = avm.require('jquery'),
    
		url_DEFAULT = 'https://avg.sng.link/Djkjd/h6qa/giqs',
		avastGlobals = typeof window.avastGlobals !== 'undefined' ? window.avastGlobals : {};

        var detected = avastGlobals.detect;

	if ((typeof avastGlobals.web !== 'undefined') && (detected.os.isAndroid || detected.os.isIOS)) {
			window.location.href = url_DEFAULT;
	} else {
		window.dataLayer.push({
			'event': 'notRedirected'
		});
	}
})();